<template>
  <SelectBox2
    title="Edit Labels"
    size="xl"
    :values="allowManage ? managedLabels : labelsCopy"
    :items="labelSelectList"
    :allow-new="allowNew"
    :label-type="ltype"
    ref="selectBox"
    @update="handleUpdate($event)"
  ></SelectBox2>
</template>

<script>
import SelectBox2 from "./SelectBox2.vue";

export default {
  name: "EditLabels",

  components: {
    SelectBox2,
  },

  data() {
    return {
      labelSelectList: [],
      labelsCopy: [],
      labelsMut: [],
      ltype: "label",
    };
  },

  props: {
    labels: Array,
    allowNew: { type: Boolean, default: false },
    allowManage: { type: Boolean, default: false },
    value: Boolean,
    labelType: { type: String, default: "label" },
  },

  computed: {
    url() {
      switch (this.ltype) {
        case "artist":
          return "/admin/api/v2/artists";

        case "genre":
          return "/admin/api/v2/genres";

        default:
          return "/admin/api/v2/labels";
      }
    },

    mutationName() {
      switch (this.ltype) {
        case "artist":
          return "media/mutateMediaArtists";

        case "genre":
          return "media/mutateMediaGenres";

        default:
          return "media/mutateMediaLabels";
      }
    },

    managedLabels() {
      switch (this.ltype) {
        case "artist":
          return this.$store.state.media.managedArtists;

        case "genre":
          return this.$store.state.media.managedGenres;

        default:
          return this.$store.state.media.managedLabels;
      }
    },
  },

  watch: {
    labels(x) {
      this.labelsCopy = x || [];
    },
    value(value) {
      if (value) this.show();
    },
    labelType(v) {
      this.ltype = v;
    },
  },

  methods: {
    show(type) {
      if (type) this.ltype = type;

      fetch(this.url)
        .then(function (resp) {
          return resp.json();
        })
        .then((resp) => {
          let allLabels = resp.data;
          const values = this.allowManage ? this.labelsMut : this.labelsCopy;

          if (values) {
            values.forEach((label) => {
              if (!this.$_.includes(allLabels, label)) {
                allLabels.push(label);
              }
            });
          }
          this.labelSelectList = this.toLabelList(allLabels);
          this.$refs.selectBox.show();
        });
    },

    toLabelList(labels) {
      return labels
        .filter((label) => label != null)
        .sort((a, b) => {
          return a < b ? -1 : a > b ? 1 : 0;
        })
        .map((label) => {
          return { value: label, text: label, selected: this.isMember(label) };
        });
    },

    isMember(label) {
      const values = this.allowManage ? this.managedLabels : this.labelsCopy;
      return values.indexOf(label) >= 0;
    },

    updateValues(newLabels) {
      this.labelsCopy = newLabels;
    },

    handleUpdate(newValues) {
      if (this.allowManage) {
        if (newValues) {
          const toRemove = this.$_.difference(this.managedLabels, newValues);
          const toAdd = this.$_.difference(newValues, this.managedLabels);
          this.$store
            .dispatch(this.mutationName, { toAdd: toAdd, toRemove: toRemove })
            .then(() =>
              this.$root.app.showAlert(
                `${
                  this.ltype == "artist"
                    ? "Artists"
                    : this.ltype == "genre"
                    ? "Genres"
                    : "Labels"
                } updated`,
                "success"
              )
            )
            .catch(() =>
              this.$root.app.showAlert(
                `There was an error while updating ${
                  this.ltype == "artist"
                    ? "artists"
                    : this.ltype == "genre"
                    ? "genres"
                    : "labels"
                }`,
                "danger"
              )
            );
        }
      } else if (newValues) {
        this.$emit("update", newValues);
      }
      this.$emit("input", false);
    },
  },

  created() {
    this.ltype = this.labelType;

    if (this.value) {
      this.show();
    }

    this.labelsCopy = this.labels;
    this.$root.$on("media-label-filter-update", this.updateValues);
  },

  beforeDestroy() {
    this.$root.$off("media-label-filter-update", this.updateValues);
  },
};
</script>

<style></style>
